module.exports = __webpack_public_path__ + "static/media/varejo-1.965b660d.jpg";